export const OFFLINE_DB_NAME = "FISKAL_BSS";

export const offline_tables = {
    all_clients: 'all_clients',
    sync_date: 'sync_date',
}